export const GAUGE_INDICATOR_MIN_VALUE = -999999999;
export const GAUGE_INDICATOR_MAX_VALUE = 999999999;
